export const Share = ({ width = '21', height = '20' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.8545 2C17.5113 2 18.8545 3.34315 18.8545 5C18.8545 6.65685 17.5113 8 15.8545 8C15.0438 8 14.3082 7.67845 13.7684 7.15593L8.85449 9.58032V10.4197L13.7684 12.8441C14.3082 12.3215 15.0438 12 15.8545 12C17.5113 12 18.8545 13.3431 18.8545 15C18.8545 16.6569 17.5113 18 15.8545 18C14.1976 18 12.8545 16.6569 12.8545 15C12.8545 14.8733 12.8623 14.7485 12.8776 14.626L7.95829 12.1387C7.41684 12.6714 6.67404 13 5.85449 13C4.19764 13 2.85449 11.6569 2.85449 10C2.85449 8.34315 4.19764 7 5.85449 7C6.67404 7 7.41684 7.32863 7.95829 7.8613L12.8776 5.374C12.8623 5.25147 12.8545 5.12665 12.8545 5C12.8545 3.34315 14.1976 2 15.8545 2Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
